import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "States Game", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "A game where you can guess the 50 US states.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Time remaining:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "States remaining:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Found:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = {
  key: 0,
  id: "game-won"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "You won!", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { id: "game-over" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Game Over!")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Missed:", -1)
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_line_chart = _resolveComponent("line-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (!_ctx.gameStarted)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startGame && _ctx.startGame(...args)))
        }, "Start Game"))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            autofocus: "",
            autocomplete: "off",
            disabled: _ctx.gameOver,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.guess) = $event))
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.guess]
          ]),
          _createElementVNode("p", null, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(Math.floor(_ctx.timer / 60).toString().padStart(2, '0')) + ":" + _toDisplayString((_ctx.timer % 60).toString().padStart(2, '0')), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.available.length) + " of " + _toDisplayString(_ctx.states.length), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.found.join(', ')), 1)
          ]),
          (_ctx.gameOver)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_9,
                (_ctx.gameWon)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _hoisted_12))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_13,
                      _createElementVNode("p", null, [
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(_ctx.available.join(', ')), 1)
                      ])
                    ], 64)),
                _createElementVNode("p", null, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startGame && _ctx.startGame(...args)))
                  }, "Restart Game"),
                  _createElementVNode("a", {
                    target: "_blank",
                    href: _ctx.tweetLink
                  }, " Tweet your result! ", 8, _hoisted_15)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 64)),
    _hoisted_16,
    _createElementVNode("span", null, [
      _createElementVNode("label", null, [
        _createTextVNode(" Show live graph: "),
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showLiveChart) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.showLiveChart]
        ])
      ])
    ]),
    (_ctx.showLiveChart || _ctx.gameOver)
      ? (_openBlock(), _createBlock(_component_line_chart, {
          key: 2,
          id: "chart",
          chartData: _ctx.foundChartData,
          options: _ctx.chartOptions
        }, null, 8, ["chartData", "options"]))
      : _createCommentVNode("", true)
  ]))
}